import styled from 'styled-components';
import { mixins } from '4all-ui/styles';
import { Row, FormGroup, Button } from '../../styles/customComponents';
import {
  GRAY_LIGHTER,
  GRAY_MEDIUM,
  GRAY_DARKER,
  FONT_SIZE_7,
  FONT_SIZE_6,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_BOLD,
  INFO_COLOR,
} from '../../styles/variables';
import { flexPosition, customScrollbar, fontStyle } from '../../styles/mixins';

export const Box = styled.form`
  background-color: #ffffff;
  border: solid 1px ${GRAY_LIGHTER};
  border-radius: 3px;
  padding: 20px 20px 10px;
  max-width: 458px;
`;

export const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 15px;

  > label {
    color: ${GRAY_DARKER};
    display: block;
    font-size: ${FONT_SIZE_7};
    font-weight: ${FONT_WEIGHT_BOLD};
    line-height: 14px;
    margin-bottom: 8px;
  }

  > input,
  > textarea {
    font-size: ${FONT_SIZE_7};
  }

  > input {
    height: 40px;
  }

  > textarea {
    height: 65px;
  }
`;

export const CancelButton = styled(Button)`
  height: 40px;
  ${fontStyle(INFO_COLOR, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  border: none;
  background: white;
  width: 100px;
  outline: none;
`;

export const StyledRow = styled(Row)`
  ${flexPosition({ align: 'flex-end', justify: 'space-between' })}
  > ${StyledFormGroup} {
    margin-bottom: 0;
    margin-right: 20px;

      &:nth-child(1) {
        max-width: ${props => (props.editing ? '110px' : '130px')};
      }

      &:nth-child(2) {
        margin-right: ${props => (props.editing ? '0px' : '')};
        max-width: 86px;
      }
  }
`;

export const Divisor = styled.hr`
  border-top-color: ${GRAY_LIGHTER};
  margin: 20px 0 20px;
`;

export const ListTitle = styled.h2`
  color: ${GRAY_DARKER};
  font-size: ${FONT_SIZE_5};
  font-weight: ${FONT_WEIGHT_NORMAL};
  line-height: 1;
  margin: 0 0 20px;
`;

export const EmptyMessage = styled.p`
  color: ${GRAY_MEDIUM};
  font-size: ${({ big }) => (big ? FONT_SIZE_5 : FONT_SIZE_6)};
  left: 50%;
  margin: -7.5px 0 0;
  max-width: 220px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const OptionList = styled.div`
  height: ${({ atLeastOneError }) => (atLeastOneError ? '119px' : '181px')};
  margin-right: -10px;
  overflow: auto;
  padding-right: 10px;
  position: relative;

  ${customScrollbar()}
`;

export const InvertContainer = styled.div`
  ${mixins.flexPosition({
    align: 'center',
    justify: 'space-between',
    direction: 'row-reverse',
  })}
  max-width: 200px;
`;



// WEBPACK FOOTER //
// ./src/components/VariationOptionForm/style.js